<template>
<!--  注册得wca弹框 -->
  <div>
    <div class="dialogBox isWCAop">
      <el-dialog
        :visible.sync="popup1"
        custom-class="is-raduis"
        width="420px"
        top="30vh"
      >
        <div style="padding: 10px 0 35px 0">
          <div >
            <div class="title">Identity</div>
            <div class="txt">What is your identity？</div>
            <ul class="clear" style="margin-left: 70px">
              <li
                class="option l"
                :class="{ active: customerOwnerType === 2 }"
                @click="customerOption(2)"
                style="margin-right: 40px"
              >
                <div>
                  <div>
                    <i class="fa option-icon">&#xe707;</i>
                  </div>
                  <div class="option-label">peer</div>
                </div>
              </li>
              <li
                class="option l"
                :class="{ active: customerOwnerType === 0 }"
                @click="customerOption(0)"
              >
                <div>
                  <div>
                    <i class="fa option-icon">&#xe706;</i>
                  </div>
                  <div class="option-label">Customers</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="dialogBox isWCAop1">
      <el-dialog
        :visible.sync="popup2"
        custom-class="is-raduis"
        width="420px"
        top="30vh"
      >
        <div style="padding: 20px 0 25px 0">
          <ul class="clear" style="margin-left: 55px">
            <li
              @click="isWCAOpt(true)"
              class="l"
              style="width: 150px; height: 60px"
            >
              <div>
                <img
                  v-show="isWCA"
                  src="@/assets/img/wcaLight.png"
                  alt="wca"
                  width="150"
                />
                <img
                  v-show="!isWCA"
                  src="@/assets/img/wca.jpg"
                  alt="wca"
                  width="150"
                />
              </div>
            </li>
            <li
              @click="isWCAOpt(false)"
              :class="{ active: !isWCA }"
              class="l option marL10"
              style="width: 150px; height: 60px"
            >
              <div>OTHERS</div>
            </li>
          </ul>
          <div style="margin-top: 28px; padding-left: 43px">
            <div v-show="isWCA">
              <span class="colRed">*</span>
              <span class="font12 colBlack marR5">ID Number:</span>
              <el-input
                v-int
                :class="{inputWarn: tip}"
                placeholder="Number Only"
                v-model.number="wcaID"
                @blur="minLen"
                @focus="tip = false"
                maxlength="10"
                class="font12"
                style="width: 240px"
              />
            </div>
          </div>
          <div style="margin-top: 28px">
            <a
              class="xBlueBtn"
              @click="sumbit"
              style="
                width: 110px;
                height: 28px;
                line-height: 28px;
                margin: auto;
              "
              >Submit</a
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="dialogBox">
      <el-dialog
        :visible.sync="sendWait"
        custom-class="loading"
        width="420px"
        top="30vh"
        :close-on-click-modal="false"
        :show-close="false"
      >
      <img
          src="@/assets/img/loading.gif"
          style="width: 50px; height: 50px; margin:50px auto"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      popup1: false,
      popup2: false,

      isWCA: true,
      wcaID: "",
      customerOwnerType: "",

      tip:false,

      sendWait: false
    };
  },
  methods: {
    customerOption(val) {
      this.customerOwnerType = val;
      if (this.customerOwnerType === 2) {
        this.popup2 = true;
      } else {
        // 选择直客
        this.$emit("getPopup", {
          customerOwnerType: this.customerOwnerType,
          wcaID: "",
          isWca: false,
        });
        this.sendWait = true
      }
    },
    clsoeAll() {
      this.popup1 = false,
      this.popup2 = false,
      this.sendWait = false
    },
    minLen() {
      if (String(this.wcaID).length !== 10) {
        this.wcaID = "";
        this.tip = true
      } else {
        this.tip = false
      }
    },
    isWCAOpt(val) {
      this.isWCA = val;
    },
    open() {
      this.popup1 = true;
    },
    sumbit() {
      // 选择同行提交
      let wcaID = this.isWCA ? this.wcaID : ""
      if(String(this.wcaID).length === 10 || !this.isWCA) {
        this.$emit("getPopup", {
          customerOwnerType: 2,
          wcaID: wcaID,
          isWca: this.isWCA,
        });
        this.sendWait = true
      }
    },
  },
};
</script>
<style >
.is-raduis {
  border-radius: 10px;
}
.loading .el-dialog__header {
  position: absolute;
}
.loading .el-dialog__body {
  position: absolute;
  left: 150px;
}
</style>
<style scoped>
.isWCAop .title {
  text-align: center;
  font-size: 17px;
  color: black;
  font-weight: bold;
}
.isWCAop .txt {
  text-align: center;
  margin-top: 6px;
  color: black;
  font-size: 14px;
  margin-bottom: 25px;
}
.isWCAop .option {
  width: 120px;
  height: 120px;
  background: #f0f0f0;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  color: black;
}

.option-icon {
  margin-top: 35px;
  font-size: 27px;
}
.option-label {
  font-size: 14px;
  margin-top: 10px;
}

.isWCAop1 .option {
  width: 148px;
  height: 58px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  color: #363636;
  line-height: 58px;
}

.active {
  background: #004fb1 !important;
  color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/reception/reg/wcaPopup.vue